import React, {useEffect} from 'react'
import {Box, BoxProps, useMultiStyleConfig} from '@chakra-ui/react'
import {HeaderActionType, useHeaderDispatch, useHeaderState} from '_context'
import Menu from '../menu/index'
import {DarkOverlay} from '_uiComponents'
import {useHeaderSizeWithoutBanner} from '_customHooks'

/**
 * @name Sidebar
 *
 * @component
 *
 * @description
 * Renders a menu and a dark overlay.
 *
 * @remarks
 * Dark Overlay component ensures that on tablet the correct background under the sidebar is rendered.
 *
 * @returns {React.FC} - The rendered sidebar component.
 */
const Sidebar: React.FC = () => {
    const {isTransparentMode, isAtTop, isSearchSectionEnabled} = useHeaderState()
    const headerSize = useHeaderSizeWithoutBanner(!isAtTop)
    const styles = useMultiStyleConfig('Sidebar', {headerSize}) as Record<string, BoxProps>
    const {dispatch} = useHeaderDispatch()

    // Ensure that on mobile hover menu item status is set on false on component unmount
    useEffect(() => {
        return () => dispatch({type: HeaderActionType.HOVER_MENU_ITEM, payload: false})
    }, [])

    return (
        <>
            <DarkOverlay variant="headerMenu" />

            <Box data-testid="sidebar" {...styles.sidebar}>
                <Menu isAtTop={isAtTop} isTransparentMode={isTransparentMode} isSearchSectionEnabled={isSearchSectionEnabled} />
            </Box>
        </>
    )
}

export default Sidebar
